import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { Amplify } from 'aws-amplify'
import outputs from '../amplify_outputs.json'
import App from './App.tsx'
import './index.css'

// Configure Amplify with the generated configuration
const amplifyConfig = {
  ...outputs,
  Auth: {
    ...outputs.auth,
    Cognito: {
      ...outputs.auth?.Cognito,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN?.replace('https://', '') || '',
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [import.meta.env.VITE_CALLBACK_URL || 'http://localhost:3000/auth'],
          redirectSignOut: [import.meta.env.VITE_LOGOUT_URL || 'http://localhost:3000'],
          responseType: 'code' as const
        }
      }
    }
  }
}

console.log('[Amplify Config] OAuth domain:', import.meta.env.VITE_COGNITO_DOMAIN?.replace('https://', ''))
console.log('[Amplify Config] Callback URL:', import.meta.env.VITE_CALLBACK_URL)

Amplify.configure(amplifyConfig)

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
)